import { useState } from "react";

const CONTENT = {
  espn: {
    appLabel: "In the ESPN app",
    web: {
      steps: [
        "Open your league on fantasy.espn.com.",
        "Copy the full address from your browser bar.",
        <>
          Paste it above. We pull out the number after{" "}
          <strong>leagueId=</strong>.
        </>,
      ],
      example: {
        prefix: "fantasy.espn.com/football/league?leagueId=",
        id: "12345678",
        suffix: "&seasonId=2026",
      },
    },
    app: {
      steps: [
        "Open the ESPN Fantasy app and go to your team.",
        "Tap the League tab, then League Info.",
        "Paste the League ID shown under Basic Settings above.",
      ],
    },
    privateNote:
      "Private league? You'll need to set it to Public in your ESPN League Settings first.",
  },
  sleeper: {
    appLabel: "In the Sleeper app",
    web: {
      steps: [
        "Open your league on sleeper.com and log in.",
        "Copy the full address from your browser bar.",
        "Paste it above. We pull out the league ID from the link.",
      ],
      example: {
        prefix: "sleeper.com/leagues/",
        id: "1072964094526828544",
        suffix: "/league",
      },
    },
    app: {
      steps: [
        "Open the Sleeper app and go to your league.",
        "Tap the league, then use the Share or Copy Link option.",
        "Paste that link above. We pull out the league ID from it.",
      ],
    },
  },
};

/** "Where to find your league link" help — platform-aware numbered steps
 * plus an annotated example address, replacing screenshot mocks with the
 * same text the user will actually see on each platform. */
function FindLeagueHelp({ platform = "espn" }) {
  const [tab, setTab] = useState(0);
  const content = CONTENT[platform] ?? CONTENT.espn;
  const tabs = ["On the web", content.appLabel];
  const active = tab === 0 ? content.web : content.app;

  return (
    <div className="booth-find-help">
      <div className="booth-find-help-tabs" role="tablist" aria-label="Device">
        {tabs.map((label, index) => (
          <button
            key={label}
            type="button"
            role="tab"
            aria-selected={tab === index}
            className={`booth-find-help-tab ${
              tab === index ? "booth-find-help-tab--active" : ""
            }`}
            onClick={() => setTab(index)}
          >
            {label}
          </button>
        ))}
      </div>

      <ol className="booth-find-help-steps">
        {active.steps.map((step, index) => (
          <li key={index}>
            <span className="booth-find-help-num">{index + 1}</span>
            <span>{step}</span>
          </li>
        ))}
      </ol>

      {active.example && (
        <div className="booth-find-help-example">
          <span className="booth-find-help-example-caption">
            What a league address looks like
          </span>
          <span className="booth-find-help-example-url">
            {active.example.prefix}
            <span className="booth-find-help-example-id">
              {active.example.id}
            </span>
            {active.example.suffix}
          </span>
          <span className="booth-find-help-example-flag">Your league ID</span>
        </div>
      )}

      {content.privateNote && (
        <span className="booth-find-help-note">{content.privateNote}</span>
      )}
    </div>
  );
}

export default FindLeagueHelp;
